export enum ColumnType {
    TEXT = "TEXT",
    URL = "URL",
    NUMBER = "NUMBER",
    PREDEFINED_OPTIONS = "PREDEFINED_OPTIONS",
}

export const allColumnTypes = [ColumnType.TEXT, ColumnType.NUMBER, ColumnType.PREDEFINED_OPTIONS]

export const resolveNameForColumnType = (type: ColumnType): string => {
    switch (type) {
        case ColumnType.TEXT:
            return "Text"
        case ColumnType.URL:
            return "URL"
        case ColumnType.NUMBER:
            return "Number"
        case ColumnType.PREDEFINED_OPTIONS:
            return "Predefined Options"
    }
}